import { render } from "./sleep.vue?vue&type=template&id=9d4ed16e&scoped=true"
import script from "./sleep.vue?vue&type=script&lang=js"
export * from "./sleep.vue?vue&type=script&lang=js"

import "./sleep.vue?vue&type=style&index=0&id=9d4ed16e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d4ed16e"]])

export default __exports__